<template>
  <div ref="blockRef" class="mx-auto px-4 max-w-2xl">
    <div
      v-if="block.text"
      :class="`prose ${block.centered ? 'text-center' : ''}`"
      v-html="block.text"
      data-gsap-target="text"
    />

    <Buttons
      v-if="block.buttons?.length"
      :buttons="block.buttons"
      :class="`mt-8 md:mt-12 ${block.centered ? 'flex flex-wrap justify-center' : ''}`"
      data-gsap-target="buttons"
    />
  </div>
</template>

<script setup lang="ts">
import type { Text } from '~/statamic/types/block';

defineProps<{
  block: Text;
}>();

let ctx: gsap.Context | null;
const blockRef = ref();

onMounted(() => {
  ctx = useGsap.context((self) => {
    if (typeof self.selector !== 'function') return;

    const text = self.selector('[data-gsap-target="text"]');
    const buttons = self.selector('[data-gsap-target="buttons"]');

    if (text?.length) {
      useGsap.from(text, {
        y: 100,
        autoAlpha: 0,
        scrollTrigger: {
          start: 'top bottom',
          trigger: blockRef.value,
        },
      });
    }

    if (buttons?.length) {
      useGsap.from(buttons, {
        y: 20,
        delay: 0.25,
        autoAlpha: 0,
        scrollTrigger: {
          start: 'top bottom',
          trigger: blockRef.value,
        },
      });
    }
  }, blockRef.value);
});

onUnmounted(() => {
  ctx?.revert();
});
</script>
